import * as styles from './FileUploadProgress.module.less';
import _ from "lodash";
import { useEffect, useState } from "react";
import { IUploadFile } from "@/twapp/server/FileEndpoint";
import { useApiServer } from "../../../hooks/useTromanService";
import { TromanDialog, TromanDialogBody, TromanDialogFooter, TromanDialogTitleHeader } from "../../TromanDialog";
import { TromanButton } from '../../Buttons';
import { ErrorDisplay } from '../../ErrorDisplay';
import { TogglePanel } from '../../TogglePanel';
import { IUploadResult, IUploadState, UploadManager } from './UploadManager';

export interface IFileUploadProgressProps {
    files?: IUploadFile[];
    busy: boolean;
    onComplete: (changed: boolean) => void;
    onClose: () => void;
}

export const FileUploadProgress = ({files, busy, onComplete, onClose}: IFileUploadProgressProps) => {
    const api = useApiServer();
    const [manager, setManager] = useState<UploadManager>();
    const [current, setCurrent] = useState<IUploadState>();
    const [result, setResult] = useState<IUploadResult>();

    useEffect(() => {
        if (manager) {
            manager.abort();
        }
        
        setCurrent(undefined);
        setResult(undefined);

        if (files && files.length > 0) {
            const newManager = new UploadManager(api, files, setCurrent);
            setManager(newManager);
            newManager.upload().then(result => {
                setCurrent(undefined);
                setResult(result);
                onComplete(result.successful.length > 0);
            });
        } else {
            setManager(undefined);
        }

    }, [files]);

    const failed = result?.failed || current?.failed;

    return (
        <TromanDialog open={!!files}>
            <TromanDialogTitleHeader title="Laddar upp dokument"/>
            <TromanDialogBody>
            {
                manager && (
                    <>
                        {
                            current && (
                                <div className={styles.current}>
                                    <div>
                                        <div className={styles.title}>Laddar upp dokument ({current.index}/{current.max})</div>
                                        <div>{current.active.FilePath}</div>
                                    </div>
                                    <TromanButton className={styles.button} onClick={() => manager.abort()} text='Avbryt'/>
                                </div>
                            )
                        }
                        {
                            result && (
                                <div>
                                    <div className={styles.title}>{result.aborted ? 'Uppladdning avbruten' : 'Uppladdning klar'}</div>
                                    <div className={styles.result}>
                                        <div>{ `${result.successful.length} dokument laddades upp`}</div>
                                        {
                                            result.successful.length > 0 && (
                                                <TogglePanel title='Visa dokument'>
                                                    {
                                                        result.successful.map(x => <div key={x.FilePath}>{x.FilePath}</div>)
                                                    }
                                                </TogglePanel>
                                            )
                                        }
                                    </div>
                                    {
                                        (result.unsuccessful.length > 0) && (
                                            <div className={styles.result}>
                                                <div>{ `${result.unsuccessful.length} dokument laddades inte upp` }</div>
                                                <TogglePanel title='Visa dokument'>
                                                    {
                                                        result.unsuccessful.map(x => <div key={x.FilePath}>{x.FilePath}</div>)
                                                    }
                                                </TogglePanel>
                                            </div>
                                        )
                                    }
                                </div>
                            )
                        }
                        {
                            failed && failed.length > 0 && (
                                <div className={styles.failed}>
                                    <div className={styles.title}>Misslyckade uppladdningar</div>
                                    {
                                        failed.map((x, i) => (
                                            <div className={styles.failedItem} key={i}>
                                                <div>{x.file.FilePath}</div>
                                                <ErrorDisplay error={x.error}/>
                                            </div>
                                        ))
                                    }
                                </div>
                            )
                        }
                    </>
                )
            }
            </TromanDialogBody>
            <TromanDialogFooter>
                <TromanButton className={styles.button} text='Stäng' disabled={!!current || (result && busy)} onClick={() => onClose()}/>
            </TromanDialogFooter>
        </TromanDialog>
    )
}